<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="main-content">
        <div class="cover-image">
          <img src="assets/images/connection-bg.png">
        </div>
        <div class="messages">
          <h2 [ngClass]="{'main-title': !isDeclined,
                          'reject-title': isDeclined}">{{title}}</h2>
          <div *ngIf="isCampaignInvitationRequest">
            <p class="message-line" *ngIf="!isDeclinedCampaign" [innerHTML]="'all_set.content_campaign' | translate"></p>
            <p class="message-line" *ngIf="isDeclinedCampaign" [innerHTML]="'all_set.content_rejected_campaign' | translate"></p>
          </div>
          <p class="message-line" *ngIf="isContactPermissionRequest" [innerHTML]="permissionContent"></p>
        </div>
        <div class="action-group">
          <a *ngIf="isContactPermissionRequest" class="reject-link" (click)="acceptOrRejectPermission(false)">{{revertPermissionLink}}</a>
          <a *ngIf="isCampaignInvitationRequest" class="reject-link" (click)="declineOrAcceptCampaignInvitation(false)">{{revertCampaignInvitationLink}}</a>
        </div>
      </div>
    </div>
  </div>
</div>
<achoo-popup #AllSetPageNotification
             [isNotification]="true"
             modelTitle="{{notificationType}}">
  <span class="no-wrap-text">{{notificationMessage}}</span>
</achoo-popup>
<achoo-popup #AllSetPageErrorModal [isSpecialPopup]="true">
  <fail-retrieve-campaign-modal *ngIf="errorType"
                                [errorType]="errorType"
                                [showTryAgainButton]="true"
                                (tryAgain)="tryAgian()">
  </fail-retrieve-campaign-modal>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-all-set/influencer-all-set.component.html